import React, { useState } from 'react';
import { Box, Flex, Stack } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Checkbox } from '@televet/kibble-ui/build/components/Checkbox';
import { Popover } from '@televet/kibble-ui/build/components/Popover';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { PopoverPlacement } from 'shared/components/Dropdown';
import FilterIconButton from 'shared/components/FilterIconButton/FilterIconButton';
import { CareActivityLogFilterType } from '../../hooks/useCareActivityLogFilters';

interface IChannelListFilterPopoverProps {
  selectedFilters: CareActivityLogFilterType[];
  isAllFiltersSelected: boolean;
  handleFilterChange: (filter: CareActivityLogFilterType) => void;
  onSelectAllFilters: () => void;
  onClearAllFilters: () => void;
}

const ActivityLogFilterLabel = {
  [CareActivityLogFilterType.BenefitUsage]: 'Benefit Usages',
  [CareActivityLogFilterType.Note]: 'Notes',
  [CareActivityLogFilterType.CareEnrollmentPayment]: 'Payments',
  [CareActivityLogFilterType.EnrollmentEvent]: 'Enrollment Events',
};

const ActivityLogFilterPopover = ({
  selectedFilters,
  isAllFiltersSelected,
  handleFilterChange,
  onSelectAllFilters,
  onClearAllFilters,
}: IChannelListFilterPopoverProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Popover
        isOpen={isOpen}
        isLazy={true}
        placement={PopoverPlacement.BottomStart}
        preventOverflow={true}
        variant="default"
        onClose={(): void => setIsOpen(false)}
        anchor={
          <FilterIconButton
            data-testid="activity-log-filter-toggle-button-container"
            buttonProps={{ 'data-testid': 'activity-log-filter-toggle-button' }}
            showBadge={!isAllFiltersSelected}
            onFilterToggle={(): void => setIsOpen((value) => !value)}
          />
        }
      >
        <Flex w="100%">
          <Button
            variant="ghostNeutral"
            size="sm"
            iconName="arrowCircle"
            onClick={(): void => {
              isAllFiltersSelected ? onClearAllFilters() : onSelectAllFilters();
            }}
            data-testid="activity-log-filter-select-all-button"
            mb={3}
            ml="auto"
          >
            {isAllFiltersSelected ? 'Clear All' : 'Select All'}
          </Button>
        </Flex>

        <Stack direction="column" spacing={3}>
          {Object.values(CareActivityLogFilterType).map((filter) => {
            return (
              <Checkbox
                w="100%"
                size="md"
                value={filter}
                key={filter}
                isChecked={selectedFilters.includes(filter)}
                onChange={(): void => handleFilterChange(filter)}
              >
                <Box ml={1}>
                  <Text as="span" size="sm" textAlign="left">
                    {ActivityLogFilterLabel[filter]}
                  </Text>
                </Box>
              </Checkbox>
            );
          })}
        </Stack>
      </Popover>
    </>
  );
};

export default ActivityLogFilterPopover;
